// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { FeatureFlagsQueries } from '../../../../types/server/modules/featureFlags/queries';

export type * from '../../../../types/server/modules/featureFlags/queries';

export const createQueries = ( requests: Requests ): FeatureFlagsQueries => ({
  FeatureFlagsById: ( id, query, headers ) => { 
          return requests.get( `/feature-flags/${id}`, query, headers ); 
        },
  FeatureFlags: ( params?, headers? ) => {
        return requests.get( `/feature-flags/:id?`, params, headers );
      },
  OrgResolvedFlagsById: ( id, query, headers ) => { 
          return requests.get( `/org-resolved-flags/${id}`, query, headers ); 
        },
  OrgResolvedFlags: ( params?, headers? ) => {
        return requests.get( `/org-resolved-flags/:id?`, params, headers );
      }
});
